import { render, staticRenderFns } from "./NewMatrixFaculty.vue?vue&type=template&id=64e962a6&"
import script from "./NewMatrixFaculty.vue?vue&type=script&lang=js&"
export * from "./NewMatrixFaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports